var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
var ImageComponent = function (_a) {
    var key = _a.key, type = _a.type, src = _a.src, alt = _a.alt, className = _a.className, size = _a.size, onError = _a.onError;
    return (React.createElement(Img, { key: key, type: type, src: src, alt: alt, className: className, size: size, onError: onError }));
};
export default ImageComponent;
var catalogSpec = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: auto;\n    height: auto;\n    max-width: 950px;\n"], ["\n    width: auto;\n    height: auto;\n    max-width: 950px;\n"])));
var customImg = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (props) { return props.size && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: ", "px;\n        height: ", "px;\n    "], ["\n        width: ", "px;\n        height: ", "px;\n    "])), props.size, props.size); });
var Img = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width:100%;\n    height:100%;\n\n    ", "\n    ", "\n"], ["\n    width:100%;\n    height:100%;\n\n    ", "\n    ", "\n"])), function (props) { return props.type === 'catalog-spec' && catalogSpec; }, function (props) { return props.type === 'customImg' && customImg; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;



//////////////////
// WEBPACK FOOTER
// ./src/detail/comments/image.tsx
// module id = 58
// module chunks = 0